// Manufacturing → Reports mode panel (scaffold; gated by VITE_MFG_SCAFFOLD_TABS).
import { useState } from "react";
import { SectionCard } from "@/components/common/SectionCard";
import { ManufacturingGateBanner } from "./ManufacturingGateBanner";
import { useManufacturingEntitlementGate } from "./useManufacturingEntitlementGate";

type RptSeg = "orders" | "receiving" | "vendors" | "audit";
const SEGMENTS: RptSeg[] = ["orders", "receiving", "vendors", "audit"];

export function ManufacturingReportsPanel() {
  const gate = useManufacturingEntitlementGate();
  const [seg, setSeg] = useState<RptSeg>("orders");

  return (
    <div className="w-full text-left space-y-4">
      <div className="flex flex-wrap items-center gap-3 justify-between">
        <h2 className="text-lg font-bold text-gray-900 dark:text-zinc-100">Reports</h2>
      </div>

      <ManufacturingGateBanner gate={gate} />

      {gate.enabled ? (
        <>
          <SectionCard title="Section">
            <div className="flex flex-wrap gap-1.5">
              {SEGMENTS.map((s) => (
                <button
                  key={s}
                  type="button"
                  className={
                    "rounded-md border px-3 py-1.5 text-xs font-medium capitalize transition-colors " +
                    (seg === s
                      ? "border-indigo-500 bg-indigo-600 text-white"
                      : "border-gray-200 bg-white text-gray-700 hover:bg-gray-50 dark:border-zinc-600 dark:bg-zinc-800 dark:text-zinc-200 dark:hover:bg-zinc-700")
                  }
                  onClick={() => setSeg(s)}
                >
                  {s}
                </button>
              ))}
            </div>
          </SectionCard>

          <SectionCard title="Snapshot">
            <div className="grid grid-cols-2 gap-3">
              <div className="rounded-xl border border-gray-100 bg-gray-50 p-3 dark:border-zinc-700 dark:bg-zinc-800/50">
                <div className="text-xs text-gray-600 dark:text-zinc-300">Records</div>
                <div className="mt-1 text-2xl font-bold text-indigo-700 dark:text-indigo-300">0</div>
              </div>
              <div className="rounded-xl border border-gray-100 bg-gray-50 p-3 dark:border-zinc-700 dark:bg-zinc-800/50">
                <div className="text-xs text-gray-600 dark:text-zinc-300">Total cost</div>
                <div className="mt-1 text-2xl font-bold text-emerald-700 dark:text-emerald-300">$0.00</div>
              </div>
            </div>
            <div className="text-sm text-gray-500 dark:text-zinc-400">No {seg} records yet.</div>
          </SectionCard>
        </>
      ) : null}
    </div>
  );
}
